module.exports = __webpack_public_path__ + "static/assets/0523ce6fadf10b29e98a428525307259.png";